module.exports = __webpack_public_path__ + "img/icon_confirmed.64fec744.svg";